import React from "react";
import { FormField as Field } from "./ui/form-field";

const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","DC",
];

export function USAddressFields({ value = {}, onChange, testIdPrefix = "addr" }) {
  function set(k, v) {
    onChange({ ...value, [k]: v });
  }
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
        <Field className="md:col-span-12" label="Rua e número">
          <input
            data-testid={`${testIdPrefix}-street`}
            className="cm-input"
            value={value.street || ""}
            onChange={(e) => set("street", e.target.value)}
            placeholder="123 Main St"
          />
        </Field>
        <Field className="md:col-span-4" label="Apartamento / Unit">
          <input
            data-testid={`${testIdPrefix}-apt`}
            className="cm-input"
            value={value.apt_number || ""}
            onChange={(e) => set("apt_number", e.target.value)}
            placeholder="Apt 4B"
          />
        </Field>
        <Field className="md:col-span-4" label="ZIP">
          <input
            data-testid={`${testIdPrefix}-zip`}
            className="cm-input"
            value={value.zip_code || ""}
            onChange={(e) => set("zip_code", e.target.value)}
            placeholder="10001"
          />
        </Field>
        <Field className="md:col-span-4" label="Estado">
          <select
            data-testid={`${testIdPrefix}-state`}
            className="cm-input"
            value={value.state || ""}
            onChange={(e) => set("state", e.target.value)}
          >
            <option value="">—</option>
            {US_STATES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </Field>
        <Field className="md:col-span-12" label="Cidade">
          <input
            data-testid={`${testIdPrefix}-city`}
            className="cm-input"
            value={value.city || ""}
            onChange={(e) => set("city", e.target.value)}
            placeholder="New York"
          />
        </Field>
      </div>
    </div>
  );
}

export function formatUSAddress(a) {
  if (!a) return "";
  const line1 = [a.street, a.apt_number ? `Apt ${a.apt_number}` : ""]
    .filter(Boolean)
    .join(" ");
  const line2 = [a.city, a.state, a.zip_code].filter(Boolean).join(", ");
  return [line1, line2].filter(Boolean).join(" — ");
}
